module.exports = __webpack_public_path__ + "img/Deal.39acb59a.svg";